export default "__VITE_ASSET__Bibd$tIb__"